import { render } from "./MaintenanceForm_old.vue?vue&type=template&id=03983fb3"
import script from "./MaintenanceForm_old.vue?vue&type=script&lang=js"
export * from "./MaintenanceForm_old.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__